import * as dashboardActions from './Dashboard.actions';
import * as dashboardSelectors from './dashboardSelectors';

const initialState = {
    status: dashboardSelectors.LOADING_STATUS
};

// eslint-disable-next-line import/no-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case dashboardActions.RLS_DASHBOARD_READY:
            return {
                ...state,
                status: action.status
            };

        default:
            return state;
    }
}
